export function minBy<T>(items: T[], selector: (item: T) => number | undefined): T | undefined {
  let minItem: T | undefined = undefined;
  let minValue: number | undefined = undefined;

  for (const item of items) {
    const value = selector(item);

    if (value == null) continue;

    if (minValue == null || value < minValue) {
      minValue = value;
      minItem = item;
    }
  }

  return minItem;
}
